const getRequiredEnv = (name, value) => {
	if (typeof value !== "string" || value.trim() === "") {
		throw new Error(`Missing required environment variable: ${name}`);
	}
	return value.trim();
};

export const baseURL = getRequiredEnv("REACT_APP_BASE_URL", process.env.REACT_APP_BASE_URL);
export const clientId = getRequiredEnv("REACT_APP_CLIENT_ID", process.env.REACT_APP_CLIENT_ID);
export const tenant = getRequiredEnv("REACT_APP_TENANT", process.env.REACT_APP_TENANT);
export const veevaVaultUrl = getRequiredEnv("REACT_APP_VEEVA_VAULT_URL", process.env.REACT_APP_VEEVA_VAULT_URL);